import { Injectable } from '@angular/core';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { timer } from 'rxjs';
import { CoverpathControllerInterface } from '../../interfaces/controller/CoverpathControllerInterface';
import { CPLogger, Category } from '../../../../common/js/logger/CPLogger';

@Injectable({
  providedIn: 'root',
})
export class AmorphicService {
  static heartBeatPoll: number = 5000;
  controller: CoverpathControllerInterface;
  private activity: boolean;

  constructor(private windowService: WindowService) {
    this.controller = this.windowService.nativeWindow.controller;

    this.setupHeartBeat();
  }

  // Should not be called in apps, use LoggerSingleton or UILoggerSingleton
  public amorphicLogError(moduleName: string, activityName: string, message: string, err) {
    const error = {
      isHumanRelated: false,
      message: err,
    };
    this.controller.amorphic.logger.error(
      {
        module: moduleName,
        function: activityName,
        category: Category.request,
        error: error,
      },
      message
    );
  }

  // Should not be called in apps, use LoggerSingleton or UILoggerSingleton
  public amorphicLogWarn(moduleName: string, activityName: string, message: string, warn) {
    this.controller.amorphic.logger.warn(
      {
        module: moduleName,
        function: activityName,
        category: Category.request,
        data: {
          warn: warn,
        },
      },
      message
    );
  }

  /**
   * Call this function periodically on a heartbeat. Anytime a model
   * property is changed, a flag is set to indicate that there are pending changes.
   * The heartbeat runs periodically to save any pending changes.
   */
  setupHeartBeat() {
    // Check for pending activity in a heartbeat
    timer(0, AmorphicService.heartBeatPoll).subscribe(() => {
      if (this.activity) {
        this.controller.publicSave();
        this.activity = false;
      }
    });
  }

  save() {
    this.activity = true;
  }
}
